import React from 'react';
import { Building2, TrendingUp, Zap } from 'lucide-react';
export function WhatWeDoSection() {
  const steps = [{
    number: '01',
    icon: Building2,
    title: 'Acquire',
    description: 'We identify and acquire well-established laundromats with strong fundamentals in key Florida markets.',
    details: ['Strategic market selection', 'Thorough due diligence', 'Fair, transparent valuations', 'Quick, professional closings']
  }, {
    number: '02',
    icon: TrendingUp,
    title: 'Optimize',
    description: 'We implement proven systems and processes to enhance efficiency and improve customer experience.',
    details: ['Modern equipment upgrades', 'Streamlined operations', 'Staff training programs', 'Quality control systems']
  }, {
    number: '03',
    icon: Zap,
    title: 'Scale',
    description: 'We leverage our platform to integrate technology and drive sustainable growth across our portfolio.',
    details: ['Technology integration', 'Brand consistency', 'Centralized support', 'Continuous improvement']
  }];
  return <section className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-[#0b1a1a] via-[#0f2424] to-[#0b1a1a] relative overflow-hidden" data-id="element-222">
      {/* Background effects */}
      <div className="absolute inset-0" data-id="element-223">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#4fd1c5]/5 rounded-full blur-3xl" data-id="element-224"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-teal-600/5 rounded-full blur-3xl" data-id="element-225"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-226">
        {/* Header */}
        <div className="text-center mb-16 sm:mb-20 lg:mb-24" data-id="element-227">
          <div className="inline-block mb-4" data-id="element-228">
            <span className="text-[#4fd1c5] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase" data-id="element-229">
              Our Approach
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight px-4" data-id="element-230">
            What We Do
          </h2>
          <div className="w-16 sm:w-24 h-1 bg-gradient-to-r from-transparent via-[#4fd1c5] to-transparent mx-auto mb-6" data-id="element-231"></div>
          <p className="text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4" data-id="element-232">
            Our systematic three-step approach transforms laundromats into
            professionally managed operations
          </p>
        </div>

        {/* Steps Grid - Enhanced Desktop Layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 max-w-7xl mx-auto" data-id="element-233">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="group bg-gradient-to-br from-[#0f2424]/80 to-[#1a3a3a]/80 backdrop-blur-sm border border-gray-800/50 rounded-2xl lg:rounded-3xl p-6 sm:p-8 lg:p-10 hover:border-[#4fd1c5]/40 hover:shadow-2xl hover:shadow-[#4fd1c5]/10 transition-all duration-500 hover:-translate-y-2" data-id="element-234">
                {/* Number & Icon */}
                <div className="flex items-center justify-between mb-6 lg:mb-8" data-id="element-235">
                  <span className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#4fd1c5]/20 group-hover:text-[#4fd1c5]/30 font-mono transition-colors duration-300" data-id="element-236">
                    {step.number}
                  </span>
                  <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br from-[#4fd1c5]/20 to-teal-600/20 flex items-center justify-center group-hover:from-[#4fd1c5]/30 group-hover:to-teal-600/30 transition-all duration-300" data-id="element-237">
                    <Icon className="h-6 w-6 sm:h-7 sm:w-7 lg:h-8 lg:w-8 text-[#4fd1c5]" data-id="element-238" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 lg:mb-5 group-hover:text-[#4fd1c5] transition-colors duration-300" data-id="element-239">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-sm sm:text-base lg:text-lg text-gray-300 leading-relaxed mb-6 lg:mb-8" data-id="element-240">
                  {step.description}
                </p>

                {/* Divider - Desktop Only */}
                <div className="hidden lg:block w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent mb-8" data-id="element-241"></div>

                {/* Details List */}
                <ul className="space-y-3 lg:space-y-4" data-id="element-242">
                  {step.details.map((detail, detailIndex) => <li key={detailIndex} className="flex items-start gap-3" data-id="element-243">
                      <div className="w-1.5 h-1.5 lg:w-2 lg:h-2 rounded-full bg-[#4fd1c5] mt-2 flex-shrink-0 group-hover:shadow-lg group-hover:shadow-[#4fd1c5]/50 transition-shadow duration-300" data-id="element-244"></div>
                      <span className="text-sm lg:text-base text-gray-400 group-hover:text-gray-300 transition-colors duration-300" data-id="element-245">
                        {detail}
                      </span>
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}